import { Component } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { SharedService } from '../../../../Services/shared.service';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { environment } from '../../../../../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-update-user-details',
  imports: [RouterModule, ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './update-user-details.component.html',
  styleUrl: './update-user-details.component.css',
})
export class UpdateUserDetailsComponent {
  object: any;
  PREP_UserInfo: any;
  isloginwithSocial :boolean=false;
  constructor(
    private _fb: FormBuilder,
    public _svc: SharedService,
    private _router: Router
  ) {}
  ngOnInit(): void {
    this.CreateForm();
    this._svc.get_Login_Status().subscribe((x) => {
      debugger;
      this.PREP_UserInfo = x;
      
      if (this.PREP_UserInfo) {
        if(this.PREP_UserInfo.password =="**")
        {
          this.isloginwithSocial =true;
        }

        const passwordValue =this.PREP_UserInfo.password == "**" ? "" : this.PREP_UserInfo.password;
        this.object.patchValue({
          username: this.PREP_UserInfo.userName,
          password: passwordValue,
          mobile: this.PREP_UserInfo.mobile,
        });
      }
    });
  }

  CreateForm() {
    this.object = this._fb.group({
      username: [null, [Validators.required, Validators.minLength(3)]],
       password: [null, [Validators.required ,Validators.minLength(3)]],
      mobile: [null, [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });
  }

  UpdateUser() {
    if (this.object.invalid) {
      this.object.markAllAsTouched();
      return;
    }
    this._svc
      .POST(this.object.value, API_End_Point.UpdateUserDetails)
      .subscribe((res: any) => {
        if (res.result === environment.Success) {
          this._svc.Notification(res.result, res.message);
          this.updateUserInfo(this.object.value);
        } else {
          this._svc.Notification(res.result, res.message);
        }
      });
  }

  updateUserInfo(Userdata: any) {
    let userInfo = JSON.parse(localStorage.getItem('PREP_UserInfo') || '{}');
    if (userInfo) {
      userInfo.mobile = Userdata.mobile;
      userInfo.password = Userdata.password;
      userInfo.userName = Userdata.username;
    }
      localStorage.setItem('PREP_UserInfo', JSON.stringify(userInfo));
      this._router.navigate(['/dashboard']);
  }
}
